import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { AuthGuard } from '../../modules/auth/auth-guard';
import { FullPageLoader } from '../../visual-components/full-page-loader/full-page-loader';
import { HomeLoggedIn } from './components/home-logged-in';
import { HomeLoggedOut } from './components/home-logged-out';

export const Overview: React.FC = () => {
  const { isAuthenticated: isLoggedIn, isLoading } = useAuth0();

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (isLoggedIn) {
    return (
      <AuthGuard>
        <HomeLoggedIn />
      </AuthGuard>
    );
  }

  return <HomeLoggedOut />;
};
